import { useEffect, useState } from "react";
import { getAllBooking } from "../../api/fetch";

function Provider() {
  const [allbooking, setAllBooking] = useState([]);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    fetchAllBooking();
  }, []);

  const fetchAllBooking = async () => {
    setLoading(true);
    try {
      const res = await getAllBooking();

      setAllBooking(res?.data);
    } catch (error) {
      console.log("Error ::", error);
    } finally {
      setLoading(false);
    }
  };

  return { allbooking, isLoading };
}

export default Provider;
